<template>
    <div class="wrap">
        <div class="top">
            <ul>
                <li>
                    <div class="today-data">
                        <div class="today-data-left">
                            <div class="today-data-title">门店数</div>
                            <div class="today-data-num">
                                <span>{{todayDeviceInfo.storeNum}}</span>
                                <span>个</span>
                            </div>
                        </div>
                        <div class="today-data-img">
                            <img
                                src="/img/home/store.png"
                                alt
                            >
                        </div>
                    </div>
                </li>
                <li>
                    <div class="today-data">
                        <div class="today-data-left">
                            <div class="today-data-title">终端总数</div>
                            <div class="today-data-num">
                                <span>{{todayDeviceInfo.allDeviceNum}}</span>
                                <span>台</span>
                            </div>
                        </div>
                        <div class="today-data-img">
                            <img
                                src="/img/home/device.png"
                                alt
                            >
                        </div>
                    </div>
                </li>
                <li>
                    <div class="today-data">
                        <div class="today-data-left">
                            <div class="today-data-title">离线终端数</div>
                            <div class="today-data-num">
                                <span>{{todayDeviceInfo.offLineDeviceNum}}</span>
                                <span>台</span>
                            </div>
                        </div>
                        <div class="today-data-img">
                            <img
                                src="/img/home/program.png"
                                alt
                            >
                        </div>
                    </div>
                </li>
                <li>
                    <div class="today-data">
                        <div class="today-data-left">
                            <div class="today-data-title">在线终端数</div>
                            <div class="today-data-num">
                                <span>{{todayDeviceInfo.onLineDeviceNum}}</span>
                                <span>台</span>
                            </div>
                        </div>
                        <div class="today-data-img">
                            <img
                                src="/img/home/material.png"
                                alt
                            >
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="main">
            <div class="content">
                <div class="content-left">
                    <div class="content-left-top">
                        <div class="statistics">
                            <div class="model-title">异常统计</div>
                            <div class="statistics-list">
                                <div class="statistics-list-left">
                                    <img
                                        src="/img/home/resoveDevice.png"
                                        alt
                                    >
                                    <div class="statistics-data">
                                        <div class="statistics-data-num">
                                            <span>{{todayUntieDeviceNum}}</span>
                                            <span>台</span>
                                        </div>
                                        <div class="statistics-data-title">解绑终端数</div>
                                    </div>
                                </div>
                            </div>
                            <div class="statistics-list">
                                <div class="statistics-list-left">
                                    <img
                                        src="/img/home/onlineDevice.png"
                                        alt
                                    >
                                    <div class="statistics-data">
                                        <div class="statistics-data-num">
                                            <span>{{todayStatistics.sevenNotLogInNum}}</span>
                                            <span>个</span>
                                        </div>
                                        <div class="statistics-data-title">7日未上线终端</div>
                                    </div>
                                </div>
                                <div class="statistics-list-right">
                                    <span @click="viewStatistics('近期未上线终端')">查看>></span>
                                    <!-- <img src="/img/home/resoveDevice.png" alt=""> -->
                                </div>
                            </div>
                            <div class="statistics-list">
                                <div class="statistics-list-left">
                                    <img
                                        src="/img/home/faileDevice.png"
                                        alt
                                    >
                                    <div class="statistics-data">
                                        <div class="statistics-data-num">
                                            <span>{{todayStatistics.issueFailureNum}}</span>
                                            <span>次</span>
                                        </div>
                                        <div class="statistics-data-title">终端任务发送失败数</div>
                                    </div>
                                </div>
                                <div class="statistics-list-right">
                                    <span @click="viewStatistics('终端任务发送失败')">查看>></span>
                                    <!-- <img src="/img/home/resoveDevice.png" alt=""> -->
                                </div>
                            </div>
                        </div>
                        <div class="device-status">
                            <div class="model-title">终端状态</div>
                            <div class="device-status-charts-list">
                                <div class="device-status-list">
                                    <div class="device-charts">
                                        <div id="onlineDevice"></div>
                                    </div>
                                    <div class="device-status-num">
                                        <div class="device-data-title">在线终端数</div>
                                        <div class="device-data-num">
                                            {{todayDeviceInfo.onLineDeviceNum}}
                                            <span>台</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="device-status-list">
                                    <div class="device-charts">
                                        <div id="offlineDevice"></div>
                                    </div>
                                    <div class="device-status-num">
                                        <div class="device-data-title device-data-title-off">离线终端数</div>
                                        <div class="device-data-num">
                                            {{todayDeviceInfo.offLineDeviceNum}}
                                            <span>台</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="device-status-list">
                                    <div class="device-charts">
                                        <div id="addDevice"></div>
                                    </div>
                                    <div class="device-status-num">
                                        <div class="device-data-title device-data-title-add">新增终端数</div>
                                        <div class="device-data-num">
                                            {{todayDeviceInfo.toDayAddDeviceNum}}
                                            <span>台</span>
                                            <span class="new-add" @click="newAddTerminal">导出>></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-right">
                    <ul class="data-content">
                        <li>
                            <div class="device-num-wrap">
                                <div class="device-num-header">
                                    <div class="device-header-title name">节目数</div>
                                    <div class="device-header-title">在线</div>
                                    <div class="device-header-title">离线</div>
                                    <div class="device-header-title">操作</div>
                                </div>
                                <div class="device-num-body" v-for="(item,name,index) in programNumList" :key="index">
                                    <div class="device-body-data name">{{name}}</div>
                                    <div class="device-body-data">{{item.onLine}}</div>
                                    <div class="device-body-data">{{item.offLine}}</div>
                                    <div class="device-body-data operation" @click="viewStatistics(index+1)">查看</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="today-data today">
                                <div class="today-data-left">
                                    <div class="today-data-title">今日下发素材</div>
                                    <div class="today-data-num">
                                        <span>{{todayPublish.fileNum}}</span>
                                        <span>个</span>
                                    </div>
                                </div>
                                <div class="today-data-left">
                                    <div class="today-data-title">今日发布节目</div>
                                    <div class="today-data-num">
                                        <span>{{todayPublish.programNum}}</span>
                                        <span>个</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content-footer">
            <div class="program-push-num">
                <div class="model-title">近7天节目上刊数</div>
                <div class="myEcharts">
                    <div id="echarts"></div>
                </div>
            </div>
            <div class="device-status-charts">
                <div class="model-title-header">
                    <div class="model-title">近7天终端状态</div>
                    <div class="legend">
                        <div class="legend-item">
                            <span
                                class="icon"
                                style="background-color: #4bba5a"
                            ></span>
                            <span>在线终端</span>
                        </div>
                        <div class="legend-item">
                            <span
                                class="icon"
                                style="background-color: #f75c78"
                            ></span>
                            <span>离线终端</span>
                        </div>
                    </div>
                </div>
                <div class="device-status">
                    <div id="deviceStatus"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import G2 from "@antv/g2";
import DataSet from "@antv/data-set";
import homeApi from "../api/home";
import echarts from "@/libs/echarts";

import myLayerImport from "@/libs/myLayer";

// import '../utils/rem'

export default {
    name: "pageFullCol",
    data() {
        return {
            todayDeviceInfo: "",

            todayProgramInfo: "",

            todayStatistics: "",

            todayPublish: "",

            todayUntieDeviceNum: "",

            programNumList:{}
        };
    },

    async created() {
        // 加载JS
        await myLayerImport();
    },

    async mounted() {
        this.fontSize = "20px";

        window.addEventListener("resize", this.resize, false);

        this.resize();
        this.init();
    },

    // 销毁监听事件
    destroyed() {
        window.removeEventListener("resize", this.resize, true);
    },

    methods: {
        init() {
            let that = this;
            // 近7天终端在线离线数量
            homeApi.sevenDeviceLineInfo().then(v => {
                let list = v.data;
                for (let item of list) {
                    item.markDate = item.markDate.slice(5);
                }
                this.deviceStatusCharts(list.reverse());
            });

            // 近7天节目发布信息数
            homeApi.sevenProgramInfo().then(v => {
                let list = v.data;
                for (let item of list) {
                    item.time = item.time.slice(5);
                }
                this.sevenProgramInfo(list.reverse());
            });

            // 今日终端信息数据统计
            homeApi.getToDayDeviceInfo().then(v => {
                this.todayDeviceInfo = v.data;
                this.onlineDeviceCharts(v.data);
                this.offlineDeviceCharts(v.data);
                this.addDeviceCharts(v.data);
            });

            // 今日节目信息统计数据
            homeApi.getToDayProgramInfo().then(v => {
                this.todayProgramInfo = v.data;
            });

            // 今日异常统计
            homeApi.getStatistics().then(v => {
                this.todayStatistics = v.data;
            });

            // 今日发布节目/素材
            homeApi.getNewToDayProgramInfo().then(v => {
                this.todayPublish = v.data;
            });

            // 今日解绑的终端数量
            homeApi.todayUntieDeviceNum().then(v => {
                this.todayUntieDeviceNum = v.data;
            });

            // 按节目数量统计终端数
            homeApi.getProgramDeviceNum().then(v => {
                let data = v.data;
                let dataObj = {};
                let dataObjOne = {}, dataObjTwo = {}, dataObjThree = {};
                for(let key in data){
                    if(/ltFive/g.test(key)){
                        if(key == 'ltFiveOnLine'){
                            dataObjOne['onLine'] = data[key];
                        }else if(key == 'ltFiveOffLine'){
                            dataObjOne['offLine'] = data[key];
                        }
                    }else if(/fiveToTen/g.test(key)){
                        if(key == 'fiveToTenOnLine'){
                            dataObjTwo['onLine'] = data[key];
                        }else if(key == 'fiveToTenOffLine'){
                            dataObjTwo['offLine'] = data[key];
                        }
                    }else if(/gtTen/g.test(key)){
                        if(key == 'gtTenOnLine'){
                            dataObjThree['onLine'] = data[key];
                        }else if(key == 'gtTenOffLine'){
                            dataObjThree['offLine'] = data[key];
                        }
                    }
                }
                dataObj["5个以下"] = dataObjOne;
                dataObj["5-10个"] = dataObjTwo;
                dataObj["10个以上"] = dataObjThree;
                this.programNumList = dataObj;
            })
        },

        resize() {
            document.documentElement.style.fontSize =
                20 * (document.documentElement.clientWidth / 1920) + "px";
        },

        // 查看异常统计
        viewStatistics(type) {
            parent.myLayer.open({
                type: 2,
                title: false,
                shadeClose: true,
                closeBtn: 0, //显示关闭按钮
                area: ["981px", "550px"],
                content:
                    this.$config.adminPath +
                    "/reportforms/:deviceId/device-statistic?type=" +
                    type,
                success: function (layero, index) { }
            });
        },

        // 近7天节目上刊数
        sevenProgramInfo111(data) {
            // let myChart = echarts.init(document.getElementById("echarts"));
            // this.$nextTick(function() {
            //   let maxData = Math.max.apply(
            //     Math,
            //     data.map(function(item) {
            //       return item.programNum;
            //     })
            //   );
            //   let dateArr = [];
            //   let programNumArr = [];
            //   let programNum = [];
            //   let allProgramNum = 0;
            //   for (let item of data) {
            //     dateArr.push(item.time);
            //     programNumArr.push(item.programNum + "个");
            //     programNum.push(item.programNum);
            //     allProgramNum += item.programNum;
            //   }
            //   let allArr = [];
            //   for (let i = 0; i < data.length; i++) {
            //     allArr.push(maxData);
            //   }
            //   // 绘制图表
            //   myChart.setOption({
            //     backgroundColor: "#fff",
            //     grid: {
            //       top: "0",
            //       left: "0.6%",
            //       right: "1%",
            //       bottom: "0",
            //       containLabel: true
            //     },
            //     yAxis: [
            //       {
            //         axisTick: "none",
            //         axisLine: "none",
            //         offset: "0",
            //         axisLabel: {
            //           textStyle: {
            //             color: "#999",
            //             fontSize: "15"
            //           }
            //         },
            //         data: dateArr
            //       },
            //       {
            //         axisTick: "none",
            //         axisLine: "none",
            //         axisLabel: {
            //           textStyle: {
            //             color: "#999",
            //             fontSize: "15"
            //           }
            //         },
            //         data: programNumArr
            //       }
            //     ],
            //     xAxis: [
            //       {
            //         type: "value",
            //         axisLabel: {
            //           show: false
            //         },
            //         axisLine: {
            //           show: false
            //         },
            //         splitLine: {
            //           show: false
            //         }
            //       }
            //     ],
            //     series: [
            //       {
            //         type: "bar",
            //         barWidth: 8,
            //         data: programNum,
            //         // label: {
            //         //   normal: {
            //         //     show: true,
            //         //     position: "insideBottomRight",
            //         //     formatter: "{c}%",
            //         //     distance: 0,
            //         //     offset: [30, -20],
            //         //     color: "#999",
            //         //     fontSize: 16,
            //         //     padding: [5, 15, 10, 15]
            //         //   }
            //         // },
            //         itemStyle: {
            //           normal: {
            //             color: new echarts.graphic.LinearGradient(
            //               1,
            //               0,
            //               0,
            //               0,
            //               [
            //                 {
            //                   offset: 0,
            //                   color: "#f3372e" // 0% 处的颜色
            //                 },
            //                 {
            //                   offset: 0.4,
            //                   color: "#762cff" // 40% 处的颜色
            //                 },
            //                 {
            //                   offset: 0.7,
            //                   color: "#5571ff" // 70% 处的颜色
            //                 },
            //                 {
            //                   offset: 1,
            //                   color: "#33b5ff" // 100% 处的颜色
            //                 }
            //               ],
            //               false
            //             ),
            //             barBorderRadius: [0, 5, 5, 0]
            //           }
            //         }
            //       },
            //       {
            //         type: "bar",
            //         barWidth: 8,
            //         xAxisIndex: 0,
            //         barGap: "-100%",
            //         data: allArr,
            //         itemStyle: {
            //           normal: {
            //             color: "#e8edf7",
            //             barBorderRadius: [0, 5, 5, 0]
            //           }
            //         },
            //         zlevel: -1
            //       }
            //     ]
            //   });
            // });
        },

        // 近7天节目上刊数
        sevenProgramInfo(data) {
            let myChart = echarts.init(document.getElementById("echarts"));

            this.$nextTick(function () {
                let maxData = Math.max.apply(
                    Math,
                    data.map(function (item) {
                        return item.programNum;
                    })
                );
                let dateArr = [];
                let programNumArr = [];
                let allProgramNum = 0;
                for (let item of data) {
                    dateArr.push(item.time);
                    programNumArr.push(item.programNum);
                    allProgramNum += item.programNum;
                }

                let allArr = [];
                for (let i = 0; i < data.length; i++) {
                    allArr.push(maxData);
                }

                // 绘制图表
                myChart.setOption({
                    backgroundColor: "#fff",
                    tooltip: {
                        trigger: "axis"
                    },
                    grid: {
                        top: "15%",
                        right: "3%",
                        left: "6%",
                        bottom: "13%"
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: dateArr,
                            axisPointer: {
                                type: "line"
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#a0a0a0"
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: "#a0a0a0",
                                    fontSize: "14"
                                }
                            },
                            splitArea: {
                                show: false
                            },
                            axisTick: {
                                show: false
                            },
                            nameTextStyle: {
                                color: "#a0a0a0"
                            },
                        }
                    ],
                    yAxis: [
                        {
                            min: 0,
                            // max: maxData,
                            axisLabel: {
                                formatter: "{value}",
                                textStyle: {
                                    color: "#a0a0a0",
                                    fontSize: "14"
                                }
                            },
                            minInterval: 1,
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#a0a0a0"
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#efefef"
                                }
                            },
                            axisTick: {
                                show: false
                            }
                        }
                    ],
                    series: [
                        {
                            name: "节目上刊数",
                            type: "bar",
                            data: programNumArr,
                            barWidth: "10px",
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        0,
                                        0,
                                        1,
                                        [
                                            {
                                                offset: 0,
                                                color: "#f3372e" // 0% 处的颜色
                                            },
                                            {
                                                offset: 0.4,
                                                color: "#762cff" // 40% 处的颜色
                                            },
                                            {
                                                offset: 0.7,
                                                color: "#5571ff" // 70% 处的颜色
                                            },
                                            {
                                                offset: 1,
                                                color: "#33b5ff" // 100% 处的颜色
                                            }
                                        ],
                                        false
                                    ),
                                    barBorderRadius: [30, 30, 0, 0]
                                    // shadowColor: "rgba(0,255,225,1)",
                                    // shadowBlur: 4
                                }
                            },
                            label: {
                                normal: {
                                    show: false,
                                    lineHeight: 30,
                                    width: 80,
                                    height: 30,
                                    backgroundColor: "#252453",
                                    borderRadius: 200,
                                    position: ["-12", "-60"],
                                    distance: 1,
                                    formatter: ["    {d|●}", " {a|{c}}     \n", "    {b|}"].join(
                                        ""
                                    ),
                                    rich: {
                                        d: {
                                            color: "#3CDDCF"
                                        },
                                        a: {
                                            color: "#fff",
                                            align: "center"
                                        },
                                        b: {
                                            width: 1,
                                            height: 30,
                                            borderWidth: 1,
                                            borderColor: "#234e6c",
                                            align: "left"
                                        }
                                    }
                                }
                            }
                        }
                    ]
                });
            });
        },

        // 在线终端数
        onlineDeviceCharts(data) {
            let myChart = echarts.init(document.getElementById("onlineDevice"));
            this.$nextTick(function () {
                // 绘制图表

                let percent =
                    ((data.onLineDeviceNum / data.allDeviceNum) * 100).toFixed(0) + "%";
                myChart.setOption({
                    backgroundColor: "#fff",
                    title: {
                        text: percent,
                        x: "center",
                        y: "center",
                        textStyle: {
                            fontWeight: "bold",
                            color: "#185eed",
                            fontSize: "26"
                        }
                    },
                    grid: {
                        containLabel: true,
                        width: "100%",
                        height: "100%",
                        right: "0",
                        bottom: "0",
                        left: "0",
                        top: "0"
                    },
                    color: ["rgba(176, 212, 251, 1)"],
                    legend: {
                        show: false,
                        itemGap: 12,
                        data: ["01", "02"]
                    },

                    series: [
                        {
                            name: "Line 1",
                            type: "pie",
                            clockWise: true,
                            startAngle: 90,
                            avoidLabelOverlap: false,
                            hoverAnimation: false,
                            radius: ["67%", "80%"],
                            itemStyle: {
                                normal: {
                                    // borderWidth: 0.6,
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                    // shadowBlur: 12,
                                    // shadowColor: 'rgba(86, 121, 255, 0.3)',
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: data.onLineDeviceNum,
                                    name: "01",
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                type: "linear",
                                                x: 0,
                                                y: 0,
                                                x2: 0,
                                                y2: 1,
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#7392ff" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 0.4,
                                                        color: "#587bff" // 40% 处的颜色
                                                    },
                                                    {
                                                        offset: 0.7,
                                                        color: "#9938ff" // 70% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#f233fb" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            },
                                            shadowBlur: 10,
                                            shadowColor: "rgba(86, 121, 255, 0.3)",
                                            shadowOffsetY: 7
                                        }
                                    }
                                },
                                {
                                    name: "02",
                                    value: data.allDeviceNum - data.onLineDeviceNum,
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#f1f1f1" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#f1f1f1" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                });
            });
        },

        // 离线终端数
        offlineDeviceCharts(data) {
            let myChart = echarts.init(document.getElementById("offlineDevice"));
            let percent =
                ((data.offLineDeviceNum / data.allDeviceNum) * 100).toFixed(0) + "%";
            this.$nextTick(function () {
                // 绘制图表
                myChart.setOption({
                    backgroundColor: "#fff",
                    title: {
                        text: percent,
                        x: "center",
                        y: "center",
                        textStyle: {
                            fontWeight: "bold",
                            color: "#f94564",
                            fontSize: "26"
                        }
                    },
                    color: ["rgba(176, 212, 251, 1)"],
                    legend: {
                        show: false,
                        itemGap: 12,
                        data: ["01", "02"]
                    },

                    series: [
                        {
                            name: "Line 1",
                            type: "pie",
                            clockWise: true,
                            startAngle: 90,
                            avoidLabelOverlap: false,
                            hoverAnimation: false,
                            radius: ["67%", "80%"],
                            itemStyle: {
                                normal: {
                                    // borderWidth: 0.6,
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                    // shadowBlur: 12,
                                    // shadowColor: 'rgba(86, 121, 255, 0.3)',
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: data.offLineDeviceNum,
                                    name: "01",
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                type: "linear",
                                                x: 0,
                                                y: 0,
                                                x2: 0,
                                                y2: 1,
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#fbe236" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 0.5,
                                                        color: "#f9554b" // 50% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#f94564" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            },
                                            shadowBlur: 10,
                                            shadowColor: "rgba(249, 69, 100, 0.3)",
                                            shadowOffsetY: 7
                                        }
                                    }
                                },
                                {
                                    name: "02",
                                    value: data.allDeviceNum - data.offLineDeviceNum,
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#f1f1f1" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#f1f1f1" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                });
            });
        },

        // 新增终端数
        addDeviceCharts(data) {
            let myChart = echarts.init(document.getElementById("addDevice"));
            let percent =
                ((data.toDayAddDeviceNum / data.allDeviceNum) * 100).toFixed(0) + "%";
            this.$nextTick(function () {
                // 绘制图表
                myChart.setOption({
                    backgroundColor: "#fff",
                    title: {
                        text: percent,
                        x: "center",
                        y: "center",
                        textStyle: {
                            fontWeight: "bold",
                            color: "#38c48a",
                            fontSize: "26"
                        }
                    },
                    color: ["rgba(176, 212, 251, 1)"],
                    legend: {
                        show: false,
                        itemGap: 12,
                        data: ["01", "02"]
                    },

                    series: [
                        {
                            name: "Line 1",
                            type: "pie",
                            clockWise: true,
                            startAngle: 90,
                            avoidLabelOverlap: false,
                            hoverAnimation: false,
                            radius: ["67%", "80%"],
                            itemStyle: {
                                normal: {
                                    // borderWidth: 0.6,
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: data.toDayAddDeviceNum,
                                    name: "01",
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                type: "linear",
                                                x: 0,
                                                y: 0,
                                                x2: 0,
                                                y2: 1,
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#9af500" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 0.4,
                                                        color: "#74e35c" // 50% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#4ed896" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            },
                                            shadowBlur: 10,
                                            shadowColor: "rgba(56, 196, 138, 0.3)",
                                            shadowOffsetY: 7
                                        }
                                    }
                                },
                                {
                                    name: "02",
                                    value: data.allDeviceNum - data.toDayAddDeviceNum,
                                    itemStyle: {
                                        normal: {
                                            color: {
                                                // 完成的圆环的颜色
                                                colorStops: [
                                                    {
                                                        offset: 0,
                                                        color: "#f1f1f1" // 0% 处的颜色
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#f1f1f1" // 100% 处的颜色
                                                    }
                                                ]
                                            },
                                            label: {
                                                show: false
                                            },
                                            labelLine: {
                                                show: false
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                });
            });
        },

        //新增终端详情导出
        newAddTerminal(){
            homeApi.exportNewAdd({
                responseType: 'blob'
            }).then(v => {
                this.$message.success("导出成功");
                let url = window.URL.createObjectURL(new Blob([v]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '新增终端数列表.xls')

                document.body.appendChild(link)
                link.click()
            }).catch(res => {
                console.log(res)
            })
        },

        // 近7天终端状态
        deviceStatusCharts(data) {
            let myChart = echarts.init(document.getElementById("deviceStatus"));
            let dateArr = [];
            let totalOffline = [];
            let totalOnline = [];
            for (let item of data) {
                dateArr.push(item.markDate);
                totalOffline.push(item.totalOffline);
                totalOnline.push(item.totalOnline);
            }
            this.$nextTick(function () {
                // 绘制图表
                myChart.setOption({
                    backgroundColor: "#fff",
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        top: "15%",
                        left: "3.5%",
                        right: "1%",
                        bottom: "5%",
                        // height: "100%",
                        containLabel: true
                    },
                    xAxis: {
                        type: "category",
                        axisLabel: {
                            textStyle: {
                                color: "#a0a0a0",
                                fontSize: "14"
                            }
                        },
                        // boundaryGap: false,
                        // offset: 10,
                        data: dateArr,
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#a0a0a0"
                            }
                        },
                        nameTextStyle: {
                            color: "#a0a0a0"
                        },
                        splitArea: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            textStyle: {
                                color: "#a0a0a0",
                                fontSize: "14"
                            }
                        },
                        minInterval: 1,
                        splitLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#efefef"
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#a0a0a0"
                            }
                        },
                        nameTextStyle: {
                            color: "#a0a0a0"
                        },
                        splitArea: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    series: [
                        {
                            name: "在线终端",
                            type: "line",
                            data: totalOnline,
                            markPoint: {
                                data: [
                                    // {type: 'max', name: '最大值'},
                                    // {type: 'min', name: '最小值'}
                                ]
                            },
                            color: "#F58080",
                            lineStyle: {
                                normal: {
                                    width: 4,
                                    color: {
                                        type: "linear",

                                        colorStops: [
                                            {
                                                offset: 0,
                                                color: "#4bba5a" // 0% 处的颜色
                                            },
                                            {
                                                offset: 0.4,
                                                color: "#4bba5a" // 100% 处的颜色
                                            },
                                            {
                                                offset: 1,
                                                color: "#4bba5a" // 100% 处的颜色
                                            }
                                        ],
                                        globalCoord: false // 缺省为 false
                                    },
                                    shadowColor: "rgba(80,188,95, 0.3)",
                                    shadowBlur: 12,
                                    shadowOffsetY: 10
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: "#4bba5a",
                                    borderWidth: 3,
                                    /*shadowColor: 'rgba(72,216,191, 0.3)',
                                       shadowBlur: 100,*/
                                    borderColor: "#4bba5a"
                                }
                            },
                            smooth: true
                        },
                        {
                            name: "离线终端",
                            type: "line",
                            data: totalOffline,
                            markPoint: {
                                data: [
                                    // {type: 'max', name: '最大值'},
                                    // {type: 'min', name: '最小值'}
                                ]
                            },
                            lineStyle: {
                                normal: {
                                    width: 4,
                                    color: {
                                        type: "linear",

                                        colorStops: [
                                            {
                                                offset: 0,
                                                color: "#f75c78" // 0% 处的颜色
                                            },
                                            {
                                                offset: 0.4,
                                                color: "#f75c78" // 100% 处的颜色
                                            },
                                            {
                                                offset: 1,
                                                color: "#f75c78" // 100% 处的颜色
                                            }
                                        ],
                                        globalCoord: false // 缺省为 false
                                    },
                                    shadowColor: "rgba(247,92,120, 0.3)",
                                    shadowBlur: 12,
                                    shadowOffsetY: 10
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: "#f75c78",
                                    borderWidth: 3,
                                    /*shadowColor: 'rgba(72,216,191, 0.3)',
                                       shadowBlur: 100,*/
                                    borderColor: "#f75c78"
                                }
                            },
                            smooth: true
                        }
                    ]
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
body {
    background: transparent;
}
.wrap {
    background: #f8f8f8;
    height: 100%;
}
.content-right ul {
    box-sizing: border-box;
    li {
        width: 100%;
        height: 165px;
        margin-bottom: 28px;
        box-sizing: border-box;
        background-color: #ffffff;
        color: #999999;
        border-radius: 6px;
        display: flex;
        align-items: center;
        &:last-child {
            margin-bottom: 0;
        }
        .today-data {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            .today-data-left {
                margin-left: 2rem;
                .today-data-title {
                    font-size: 1rem;
                    color: #999999;
                    line-height: 1rem;
                }
                .today-data-num {
                    font-size: 2.9rem;
                    color: #282828;
                    line-height: 2.9rem;
                    margin-top: 0.6rem;
                    font-weight: 600;
                    span:last-child {
                        font-size: 0.9rem;
                        line-height: 0.9rem;
                        color: #282828;
                        margin-left: 0.2rem;
                    }
                }
            }
            .today-data-img {
                margin-right: 0.8rem;
                img {
                    width: 6.2rem;
                    height: 6.2rem;
                }
            }
        }
    }
}

.top ul {
    display: flex;
    box-sizing: border-box;
    li {
        width: 25%;
        height: 165px;
        margin-right: 28px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        &:first-child {
            background-image: linear-gradient(90deg, #4e71fd 0%, #c97afd 100%),
                linear-gradient(#252b48, #252b48);
            background-blend-mode: normal, normal;
            box-shadow: 0px 10px 20px 0px rgba(199, 122, 253, 0.3);
        }
        &:nth-child(2) {
            background-image: linear-gradient(90deg, #3daef6 0%, #747bfc 100%),
                linear-gradient(#252b48, #252b48);
            background-blend-mode: normal, normal;
            box-shadow: 0px 10px 20px 0px rgba(61, 174, 246, 0.3);
        }
        &:nth-child(3) {
            background-image: linear-gradient(90deg, #ea6380 0%, #f09f5c 100%),
                linear-gradient(#252b48, #252b48);
            background-blend-mode: normal, normal;
            box-shadow: 0px 10px 20px 0px rgba(240, 158, 92, 0.3);
        }
        &:last-child {
            margin-right: 0;
            background-image: linear-gradient(
                    90deg,
                    #41d79c 0%,
                    #74dd7e 65%,
                    #a7e25f 100%
                ),
                linear-gradient(#252b48, #252b48);
            background-blend-mode: normal, normal;
            box-shadow: 0px 10px 20px 0px rgba(165, 226, 96, 0.3);
        }
        .today-data {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
        }
    }
}
.today-data {
    .today-data-left {
        margin-left: 2rem;
        .today-data-title {
            font-size: 1rem;
            color: #fefeff;
            line-height: 1rem;
        }
        .today-data-num {
            font-size: 2.9rem;
            color: #ffffff;
            line-height: 2.9rem;
            margin-top: 0.6rem;
            font-weight: 600;
            span:last-child {
                font-size: 0.9rem;
                line-height: 0.9rem;
                color: #fefeff;
                margin-left: 0.2rem;
            }
        }
    }
    .today-data-img {
        margin-right: 0.8rem;
        img {
            width: 6.2rem;
            height: 6.2rem;
        }
    }
}
.main {
    margin-top: 28px;
    .content {
        display: flex; // height: 734px;
        .content-left {
            width: 75%;
            margin-right: 28px;
            box-sizing: border-box;
        }
        .content-right {
            width: calc(25% - 21px);
            width: -webkit-calc(25% - 21px);
            border-radius: 6px;
            background-image: url(/img/home/circle.png);
            background-repeat: no-repeat;
            background-position: right 540px;
            background-size: 32px 116px;
        }
    }
}
.content-left-top {
    display: flex;
    // height: 352px;
    .statistics {
        width: calc(33.33% - 18.66px);
        width: -webkit-calc(33.33% - 18.66px);
        background: #ffffff;
        margin-right: 28px;
        box-sizing: border-box;
        padding: 22px 22px 28px;
        border-radius: 6px;
        background-image: url(/img/home/circle.png);
        background-repeat: no-repeat;
        background-position: right 30px;
        background-size: 32px 116px;
    }
    .device-status {
        flex: 1;
        background: #ffffff;
        padding: 22px 22px 22px;
        box-sizing: border-box;
        border-radius: 6px;
    }
}
.model-title {
    font-size: 20px;
    line-height: 22px;
    padding-left: 12px;
    font-weight: normal;
    font-stretch: normal;
    color: #282828;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    &::before {
        content: "";
        width: 4px;
        height: 16px;
        background-color: #ff341b;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
.statistics-list {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 26px;
    .statistics-list-left {
        display: flex;
        align-items: center;
        img {
            width: 70px;
            height: 70px;
        }
        .statistics-data {
            margin-left: 22px;
            color: #282828;
            .statistics-data-num {
                font-size: 34px;
                line-height: 34px;
                font-weight: 600;
                letter-spacing: 1.2px;
                span:last-child {
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 600;
                    letter-spacing: 1.4px;
                    margin-left: 3px;
                }
            }
            .statistics-data-title {
                font-size: 16px;
                line-height: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0.8px;
                color: #999999;
                margin-top: 8px;
            }
        }
    }
    .statistics-list-right {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1.6px;
        color: #34b3ff;
        span {
            cursor: pointer;
        }
    }
}
.device-status-charts-list {
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.device-status-list {
    padding: 10px 0px 0px 0px;
    padding-left: 0;
    // display: flex;
    // align-items: center; // justify-content: space-between;
    text-align: center;
    .device-charts {
        flex: 1;
        padding: 5px 0px;
    }
    .device-status-num {
        .device-data-title {
            font-size: 22px;
            line-height: 22px;
            color: #185eed;
        }
        .device-data-title-off {
            color: #f94564;
        }
        .device-data-title-add {
            color: #38c48a;
        }
        .device-data-num {
            position: relative;
            font-size: 28px;
            line-height: 28px;
            color: #282828;
            font-weight: 600;
            margin-top: 12px;
            span {
                font-size: 18px;
                line-height: 18px;
                color: #282828;
                font-weight: 400;
            }
            .new-add{
                position: absolute;
                right:-10px;
                bottom:0px;
                font-size:14px;
                color: #34b3ff;
                cursor: pointer;
            }
        }
    }
}
.content-footer {
    margin-top: 28px;
    height: 400px;
    border-radius: 6px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    .program-push-num {
        padding: 22px 22px 22px 22px;
        background: #ffffff;
        margin-right: 28px;
        width: calc(50% - 14px);
        width: -webkit-calc(50% - 14px);
    }
    .device-status-charts {
        padding: 22px 22px 28px 22px;
        background: #ffffff;
        width: calc(50% - 14px);
        width: -webkit-calc(50% - 14px);
    }
}
#echarts {
    width: 100%;
    height: 338px;
}

#onlineDevice {
    width: 190px;
    height: 190px;
}

#offlineDevice {
    width: 190px;
    height: 190px;
}

#addDevice {
    width: 190px;
    height: 190px;
}

#deviceStatus {
    width: 100%;
    height: 338px;
}

.model-title-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.legend {
    display: flex;
    margin-right: 6px;
}

.legend-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-right: 20px;
    .icon {
        width: 10px;
        height: 10px;
        background: #00cfcd;
        border-radius: 7px;
        margin-right: 4px;
    }
}
.legend-item:last-child {
    margin-right: 0;
}

.content{
    .content-right{
        .data-content{
            display: flex;
            flex-direction: column;
            height:100%;
            li{
                align-items: stretch;
                &:first-child{
                    flex:1;
                    .device-num-wrap{
                        display: flex;
                        flex:1;
                        flex-direction: column;
                        .device-num-header,.device-num-body{
                            display: flex;
                            flex:1;
                            align-items: center;
                            text-align: center;
                            .device-header-title{
                                flex:1;
                                font-size: 20px;
                                font-weight: 600;
                                color:#000;
                            }
                            .device-body-data{
                                flex:1;
                                font-size: 16px;
                            }
                            .operation{
                                font-size: 14px;
                                color: #34b3ff;
                                cursor: pointer;
                            }
                            .name{
                                flex:2;
                            }
                        }
                    }
                }
                &:last-child{
                    height:120px;
                    padding:0px 35px;
                    .today-data .today-data-left{
                        margin-left: 0px;
                    }
                }
            }
        }
    }
}
</style>

